import { SetValueModal } from "../../../../common/components/SetValueModal";
import { useState } from "react";
import { find } from "lodash";
import { Item } from "../../../../common/models";

interface AddNewOptionModalProps {
    isOpen: boolean;
    options: Item[];
    onAddNewOption: (value: string) => void;
    onCancel: () => void;
    labels: {
        title: string;
        description?: string;
        label: string;
        errorMessage?: string;
    };
}

const AddNewOptionModal = (props: AddNewOptionModalProps) => {
    const { options, onAddNewOption, isOpen, onCancel, labels } = props;

    const [newOption, setNewOption] = useState("");
    const [isNewOptionValid, setIsNewOptionValid] = useState(true);

    const handleAddNewSpacePurpose = () => {
        if (!newOption.trim()) {
            return;
        }

        const isExisting = find(options, {
            label: newOption,
        });
        if (isExisting) {
            setIsNewOptionValid(false);
            return;
        }

        onAddNewOption(newOption);
        setIsNewOptionValid(true);
        setNewOption("");
        onCancel();
    };

    const handleCancelAddNewSpacePurpose = () => {
        setNewOption("");
        setIsNewOptionValid(true);
        onCancel();
    };

    const handleChangeNewSpacePurpose = (value: string) => {
        setNewOption(value);
    };

    return (
        <SetValueModal
            isOpen={isOpen}
            labels={labels}
            onClickOk={handleAddNewSpacePurpose}
            onClickCancel={handleCancelAddNewSpacePurpose}
            onChange={handleChangeNewSpacePurpose}
            value={newOption}
            errorMessage={isNewOptionValid ? "" : labels.errorMessage}
        />
    );
};

export default AddNewOptionModal;
